// extracted by mini-css-extract-plugin
export default {"BlueCrossStar":"BlueCrossStar_BlueCrossStar__YUWt+"};